export interface ArticleSection {
  type: 'paragraph' | 'heading' | 'image' | 'list' | 'tip';
  text?: string;
  items?: string[];
  url?: string;
  caption?: string;
}

export interface Article {
  id: string;
  title: string;
  cover: string;
  date: string;
  category: string;
  type: 'news' | 'guide';
  summary: string;
  author: string;
  tags: string[];
  readTime: string;
  views: number;
  likes: number;
  content: ArticleSection[];
}

export const newsList: Article[] = [
  {
    id: 'news-6-2-release',
    title: '《原神》6.2版本「霜夜与誓约」正式上线，至冬国新区域开放',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20fantasy%20snowy%20northern%20city%20at%20night%20with%20glowing%20lanterns%20tall%20white%20towers%20and%20warm%20orange%20light%20against%20cool%20blue%20tones%2C%20clean%20minimal%20anime%20promotional%20illustration&width=800&height=500&seq=news-6201&orientation=landscape',
    date: '2026-10-10',
    category: '版本更新',
    type: 'news',
    summary:
      '6.2版本正式服开启，开放至冬国「白匣城」大型区域，新增冰系五星角色、全新世界任务线与秘境挑战，并同步调整部分元素反应数值。',
    author: '情报站编辑部',
    tags: ['6.2版本', '至冬国', '新地图', '版本前瞻'],
    readTime: '6 分钟',
    views: 58210,
    likes: 3420,
    content: [
      { type: 'heading', text: '版本核心内容概览' },
      {
        type: 'paragraph',
        text: '6.2版本「霜夜与誓约」于10月10日正式上线，本次更新最受关注的是至冬国首个大型开放区域「白匣城」。该区域以极寒雪原与机械堡垒为核心，包含全新的解谜机关、地脉异常与限时挑战。',
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=Anime%20fantasy%20frozen%20fortress%20interior%20with%20blue%20crystal%20light%20and%20snow%20falling%2C%20cinematic%20wide%20composition%2C%20clean%20illustration%20style%20promotional%20game%20art&width=900&height=520&seq=news-6202&orientation=landscape',
        caption: '全新区域「白匣城」场景预览',
      },
      {
        type: 'list',
        items: [
          '新增五星冰系角色「白枢」，长柄武器定位，主打站场输出',
          '新增世界任务「霜夜的誓约」系列，共 5 幕',
          '新增圣遗物秘境「曜金之诗」与周本首领「霜烬之匣」',
          '尘歌壶新增雪原主题家具与洞天形态',
        ],
      },
      {
        type: 'tip',
        text: '建议优先完成主线任务解锁快速传送点，再推进支线，可显著提升探索效率。',
      },
    ],
  },
  {
    id: 'news-6-2-character',
    title: '6.2版本新角色「白枢」解析：冰系主C强度与配队前瞻',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20character%20with%20silver%20blue%20hair%20holding%20a%20polearm%2C%20ice%20magic%20around%20hands%2C%20cool%20blue%20gradient%20background%20with%20soft%20snow%2C%20clean%20illustration%20style%20promotional%20art&width=800&height=500&seq=news-6205&orientation=landscape',
    date: '2026-10-08',
    category: '版本更新',
    type: 'news',
    summary:
      '新五星角色「白枢」拥有高频冰伤与增伤机制，兼顾站场输出与后台挂冰，是当前冰系队伍的重要一环。本文从定位、技能与配队三方面进行解析。',
    author: '攻略组 · 苏澈',
    tags: ['白枢', '冰系主C', '配队', '角色解析'],
    readTime: '8 分钟',
    views: 47330,
    likes: 2890,
    content: [
      { type: 'heading', text: '角色定位' },
      {
        type: 'paragraph',
        text: '「白枢」是一名以重击与元素战技为核心的冰系站场输出角色，元素爆发可提供团队暴击率增益，兼具输出与增益能力，在融化、冻结两套体系中都具备良好表现。',
      },
      { type: 'heading', text: '技能与加点优先级' },
      {
        type: 'list',
        items: [
          '普通攻击 · 白霜剑式：重击为主要输出手段，优先升级',
          '元素战技 · 霜环：提供持续冰附着与减抗，次优先',
          '元素爆发 · 曜金裂冰：高倍率范围伤害并提升全队暴击率',
        ],
      },
      {
        type: 'tip',
        text: '搭配「炽烈的炎之魔女」套时可走融化流，搭配「冰风迷途的勇士」则更适合冻结体系的稳定输出。',
      },
      {
        type: 'paragraph',
        text: '总体来看，「白枢」对操作要求中等，适合作为冰系核心培养，值得投入资源抽取与培养。',
      },
    ],
  },
  {
    id: 'news-lantern-2026',
    title: '海灯节活动「流光映雪」玩法全解析与奖励一览',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20festival%20lanterns%20floating%20over%20a%20traditional%20eastern%20water%20city%20at%20night%20with%20golden%20glow%20and%20soft%20bokeh%2C%20clean%20anime%20festival%20illustration%20art&width=800&height=500&seq=news-lantern1&orientation=landscape',
    date: '2026-10-05',
    category: '活动资讯',
    type: 'news',
    summary:
      '海灯节限定活动「流光映雪」已开启，包含灯谜解谜、限时副本与兑换商店三大板块，本文整理全部玩法与奖励兑换优先级。',
    author: '情报站编辑部',
    tags: ['海灯节', '限时活动', '奖励', '活动攻略'],
    readTime: '5 分钟',
    views: 39870,
    likes: 2140,
    content: [
      { type: 'heading', text: '活动概况' },
      {
        type: 'paragraph',
        text: '本次活动持续至11月上旬，分为三部分：每日灯谜、限时挑战副本「流光之径」以及节庆商店。完成全部内容预计可获得原石、经验书与天赋材料等大量奖励。',
      },
      {
        type: 'list',
        items: [
          '每日灯谜：每日3题，答对获取活动代币',
          '限时副本：分难度开放，推荐携带水系与冰系角色',
          '节庆商店：优先兑换智识之冕与限定摆设',
        ],
      },
      {
        type: 'tip',
        text: '活动代币每日有获取上限，建议每天上线完成灯谜，避免最后一天堆积任务。',
      },
    ],
  },
  {
    id: 'news-abyss-12',
    title: '深境螺旋12层满星通关思路与阵容推荐',
    cover:
      'https://readdy.ai/api/search-image?query=Dark%20mysterious%20floating%20stone%20platform%20in%20a%20glowing%20void%20with%20purple%20and%20teal%20energy%2C%20dramatic%20fantasy%20anime%20game%20background%20illustration%20clean%20composition&width=800&height=500&seq=news-abyss1&orientation=landscape',
    date: '2026-10-03',
    category: '玩法攻略',
    type: 'news',
    summary:
      '本期深境螺旋12层新增地脉异常效果，本文提供上下半间的通关思路、阵容搭配与站位技巧，帮助玩家稳定触发满星。',
    author: '攻略组 · 林澈',
    tags: ['深境螺旋', '满星', '阵容', '爬塔'],
    readTime: '9 分钟',
    views: 45210,
    likes: 3050,
    content: [
      { type: 'heading', text: '本期地脉异常' },
      {
        type: 'paragraph',
        text: '本期上半间提升角色元素爆发伤害，下半间则加强重击输出，因此上下半间的阵容思路应有所区分，优先考虑爆发型与水系重击角色。',
      },
      { type: 'heading', text: '推荐阵容' },
      {
        type: 'list',
        items: [
          '上半：雷电将军 + 纳西妲 + 枫原万叶 + 班尼特',
          '下半：白枢 + 行秋 + 香菱 + 钟离',
          '备选：那维莱特 + 夜兰 + 万叶 + 钟离',
        ],
      },
      {
        type: 'tip',
        text: '12-3 的Boss在血量阶段会释放高额范围伤害，携带钟离护盾可显著降低容错压力。',
      },
    ],
  },
  {
    id: 'news-teapot',
    title: '尘歌壶「洞天百宝」新增家具与摆设搭配攻略',
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20eastern%20style%20floating%20island%20home%20garden%20with%20wooden%20pavilion%20and%20cherry%20blossoms%2C%20soft%20daylight%2C%20clean%20anime%20illustration%20art&width=800&height=500&seq=news-teapot1&orientation=landscape',
    date: '2026-09-28',
    category: '活动资讯',
    type: 'news',
    summary:
      '「洞天百宝」本周上新一批雪原主题家具，本文介绍新增摆设的获取方式与高分搭配思路，帮助你打造独一无二的洞天。',
    author: '情报站编辑部',
    tags: ['尘歌壶', '家具', '摆设', '装扮'],
    readTime: '4 分钟',
    views: 22140,
    likes: 1180,
    content: [
      { type: 'heading', text: '本周上新' },
      {
        type: 'paragraph',
        text: '本次新增「霜夜」系列家具共24件，包含建筑、庭院与室内摆件三类，可在洞天百宝中使用洞天宝钱兑换。',
      },
      {
        type: 'list',
        items: [
          '建筑：雪原木屋、暖炉壁炉',
          '庭院：冰晶灯座、雪松盆栽',
          '室内：北境挂毯、毛绒坐垫',
        ],
      },
      {
        type: 'tip',
        text: '搭配雪原洞天形态使用同主题家具，可激活额外氛围加成，提升洞天仙力评分。',
      },
    ],
  },
  {
    id: 'news-maintenance',
    title: '10月12日服务器维护公告与补偿说明',
    cover:
      'https://readdy.ai/api/search-image?query=Clean%20abstract%20fantasy%20notice%20background%20with%20soft%20blue%20gradient%20and%20glowing%20geometric%20runes%2C%20minimal%20elegant%20game%20ui%20illustration&width=800&height=500&seq=news-maint1&orientation=landscape',
    date: '2026-09-25',
    category: '游戏公告',
    type: 'news',
    summary:
      '为更新6.2版本内容，服务器将于10月12日进行停服维护，维护期间无法登录游戏，补偿邮件将在开服后发放。',
    author: '官方公告',
    tags: ['维护', '公告', '补偿'],
    readTime: '2 分钟',
    views: 31200,
    likes: 960,
    content: [
      { type: 'heading', text: '维护时间' },
      {
        type: 'paragraph',
        text: '维护预计于10月12日 06:00 开始，持续约5小时，具体开服时间以游戏内公告为准。',
      },
      {
        type: 'list',
        items: ['补偿内容：原石 ×300、脆弱树脂 ×2', '补偿对象：维护前已解锁游戏的旅行者', '发放方式：开服后通过游戏内邮件领取'],
      },
      { type: 'tip', text: '补偿邮件有效期为30天，请及时登录领取。' },
    ],
  },
  {
    id: 'news-imaginarium',
    title: '幻想真境剧诗新赛季机制改动一览',
    cover:
      'https://readdy.ai/api/search-image?query=Magical%20theater%20stage%20with%20glowing%20curtains%20and%20floating%20cards%2C%20warm%20gold%20and%20deep%20red%20tones%2C%20clean%20fantasy%20anime%20game%20illustration&width=800&height=500&seq=news-imag1&orientation=landscape',
    date: '2026-09-22',
    category: '玩法攻略',
    type: 'news',
    summary:
      '新赛季幻想真境剧诗调整了开幕角色池与祝福机制，本文整理关键改动并给出高胜率通关思路。',
    author: '攻略组 · 苏澈',
    tags: ['幻想真境剧诗', '机制', '通关'],
    readTime: '6 分钟',
    views: 27650,
    likes: 1620,
    content: [
      { type: 'heading', text: '主要改动' },
      {
        type: 'paragraph',
        text: '本赛季新增了「祝福叠加」机制，连续通关可获得递增增益，鼓励玩家保持阵容连贯性。同时开幕角色池加入了更多四星辅助。',
      },
      {
        type: 'list',
        items: ['新增祝福叠加机制', '开幕角色池更新，加入多名四星辅助', '部分首领关卡属性调整，草系受益提升'],
      },
      { type: 'tip', text: '优先保留能提供治疗与护盾的角色，可大幅提升后期关卡的生存能力。' },
    ],
  },
  {
    id: 'news-fishing',
    title: '钓鱼系统新增稀有鱼类与成就攻略',
    cover:
      'https://readdy.ai/api/search-image?query=Serene%20lakeside%20at%20golden%20sunset%20with%20wooden%20dock%20and%20misty%20mountains%2C%20soft%20warm%20light%2C%20clean%20anime%20illustration%20art&width=800&height=500&seq=news-fish1&orientation=landscape',
    date: '2026-09-18',
    category: '玩法攻略',
    type: 'news',
    summary:
      '钓鱼系统本次更新加入多种稀有鱼类与全新成就，本文汇总各鱼种出现时间与钓取技巧。',
    author: '情报站编辑部',
    tags: ['钓鱼', '成就', '收集'],
    readTime: '5 分钟',
    views: 19880,
    likes: 870,
    content: [
      { type: 'heading', text: '新增鱼种' },
      { type: 'paragraph', text: '本次共新增12种稀有鱼类，分布于蒙德、璃月、稻妻等各区域，部分鱼种仅在特定天气与时段出现。' },
      {
        type: 'list',
        items: ['霜鳍鱼：仅雪天夜晚出现在至冬国水域', '霞光鲤：晴天黄昏出现在璃月港口', '雷鸣鲈：雷雨天气出现在稻妻近海'],
      },
      { type: 'tip', text: '使用对应鱼饵并保持钓竿张力在安全区间，可显著提高上钩成功率。' },
    ],
  },
  {
    id: 'news-tcg',
    title: '七圣召唤新卡牌平衡性调整公告',
    cover:
      'https://readdy.ai/api/search-image?query=Fantasy%20trading%20card%20game%20table%20with%20glowing%20cards%20and%20chess%20board%2C%20warm%20lamp%20light%2C%20clean%20anime%20illustration%20art&width=800&height=500&seq=news-tcg1&orientation=landscape',
    date: '2026-09-15',
    category: '游戏公告',
    type: 'news',
    summary:
      '七圣召唤本次更新对部分强势卡牌进行调整，并新增数张支援牌，本文整理全部改动与天梯环境影响。',
    author: '官方公告',
    tags: ['七圣召唤', '平衡调整', '公告'],
    readTime: '4 分钟',
    views: 16420,
    likes: 720,
    content: [
      { type: 'heading', text: '调整概要' },
      { type: 'paragraph', text: '本次调整以削弱高强度速攻卡组、加强中速控制卡组为目标，同时对多张事件牌的费用与效果进行了微调。' },
      {
        type: 'list',
        items: ['下调部分速攻角色卡伤害', '新增三张支援牌，强化资源运营', '调整部分食物与元素骰相关效果'],
      },
      { type: 'tip', text: '调整后中速卡组的稳定性提升，建议重新评估原有卡组的强度与对局节奏。' },
    ],
  },
  {
    id: 'news-6-1-preview',
    title: '6.1版本前瞻：新武器与圣遗物套装解析',
    cover:
      'https://readdy.ai/api/search-image?query=Glowing%20legendary%20weapons%20and%20armor%20artifacts%20displayed%20on%20a%20dark%20velvet%20surface%20with%20soft%20spotlight%2C%20clean%20fantasy%20rpg%20item%20illustration&width=800&height=500&seq=news-6101&orientation=landscape',
    date: '2026-09-10',
    category: '版本更新',
    type: 'news',
    summary:
      '6.1版本上线两把五星武器与两套新圣遗物，本文解析其属性、适配角色与抽取优先级。',
    author: '攻略组 · 林澈',
    tags: ['6.1版本', '武器', '圣遗物'],
    readTime: '7 分钟',
    views: 34900,
    likes: 1980,
    content: [
      { type: 'heading', text: '新武器概览' },
      { type: 'paragraph', text: '本次上线的五星长柄武器「白霜之誓」适合站场输出角色，副属性提供暴击率，被动提升冰元素伤害与重击加成。' },
      {
        type: 'list',
        items: ['白霜之誓（长柄武器）：冰伤与重击流适配', '潮汐回响（法器）：生命值与重击加成' ],
      },
      {
        type: 'tip',
        text: '如已拥有同类型的五星武器，可优先考虑抽取新角色，避免资源分散。',
      },
    ],
  },
  {
    id: 'guide-zhongli',
    title: '钟离攻略：玉璋护盾机制与辅助配队全解析',
    cover:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20an%20elegant%20mature%20male%20with%20long%20dark%20brown%20hair%20and%20amber%20eyes%20wearing%20ornate%20black%20and%20gold%20traditional%20long%20coat%20soft%20warm%20rim%20light%20plain%20cream%20gradient%20background%20high%20detail&width=800&height=500&seq=char-zhongli&orientation=portrait',
    date: '2026-10-06',
    category: '角色攻略',
    type: 'guide',
    summary:
      '钟离是岩元素五星长柄武器角色，以玉璋护盾与全元素减抗闻名。本文详解护盾机制、天赋加点与主流辅助配队。',
    author: '攻略组 · 苏澈',
    tags: ['钟离', '岩元素', '护盾', '辅助'],
    readTime: '7 分钟',
    views: 61340,
    likes: 4210,
    content: [
      { type: 'heading', text: '角色定位' },
      { type: 'paragraph', text: '钟离的核心价值在于元素战技「地心」生成的玉璋护盾，能够提供高额护盾并大幅降低周围敌人的全元素抗性与物理抗性，是队伍中的优质生存与增伤辅助。' },
      { type: 'heading', text: '天赋加点优先级' },
      { type: 'list', items: ['元素战技「地心」：优先满级，直接影响护盾量与减抗', '元素爆发「天星」：次优先，提供大范围岩伤与石化', '普通攻击：可不升级'] },
      { type: 'heading', text: '配队思路' },
      { type: 'list', items: ['万能搭配：主C + 钟离 + 班尼特 + 万叶', '岩队：荒泷一斗 + 钟离 + 阿贝多 + 五郎'] },
      { type: 'tip', text: '护盾生命值上限越高越厚，圣遗物优先堆叠生命值与元素充能效率。' },
    ],
  },
  {
    id: 'guide-hutao',
    title: '胡桃攻略：血梅香机制与蒸发输出循环详解',
    cover:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20cheerful%20young%20woman%20with%20dark%20brown%20twin%20tails%20and%20red%20eyes%20wearing%20a%20black%20and%20red%20traditional%20outfit%20warm%20rim%20light%20plain%20cream%20gradient%20background%20high%20detail&width=800&height=500&seq=char-hutao&orientation=portrait',
    date: '2026-10-04',
    category: '角色攻略',
    type: 'guide',
    summary:
      '胡桃是火元素五星长柄武器角色，以低血量高倍率与元素附魔重击输出著称。本文详解血梅香机制、输出循环与蒸发配队。',
    author: '攻略组 · 林澈',
    tags: ['胡桃', '火元素', '主C', '蒸发'],
    readTime: '8 分钟',
    views: 57620,
    likes: 3980,
    content: [
      { type: 'heading', text: '角色定位' },
      { type: 'paragraph', text: '胡桃通过元素战技「彼岸蝶舞」将血量转化为攻击力加成，并让普通攻击附带火元素，是典型的高风险高回报站场主C。' },
      { type: 'heading', text: '输出循环' },
      { type: 'list', items: ['开启元素战技后打完约9次重击', '保持血量在50%以下以触发天赋加成', '元素爆发用于斩杀或回血保命'] },
      { type: 'heading', text: '推荐配队' },
      { type: 'list', items: ['胡桃 + 行秋 + 钟离 + 万叶', '胡桃 + 夜兰 + 钟离 + 班尼特'] },
      { type: 'tip', text: '护摩之杖与「炽烈的炎之魔女」四件套是当前最优选择，副词条优先暴击伤害与生命值。' },
    ],
  },
  {
    id: 'guide-ganyu',
    title: '甘雨攻略：霜华矢蓄力机制与融化流配队',
    cover:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20gentle%20young%20woman%20with%20light%20blue%20hair%20and%20purple%20eyes%20wearing%20a%20white%20and%20blue%20decorated%20outfit%20with%20flowers%20cool%20soft%20light%20plain%20cream%20gradient%20background&width=800&height=500&seq=char-ganyu&orientation=portrait',
    date: '2026-10-01',
    category: '角色攻略',
    type: 'guide',
    summary:
      '甘雨是冰元素五星弓角色，霜华矢蓄力射击可在后台持续输出，融化流与冻结流均有出色表现。',
    author: '攻略组 · 苏澈',
    tags: ['甘雨', '冰元素', '主C', '融化'],
    readTime: '7 分钟',
    views: 48900,
    likes: 3120,
    content: [
      { type: 'heading', text: '角色定位' },
      { type: 'paragraph', text: '甘雨的二段蓄力「霜华矢」拥有极高倍率并附带范围冰伤，是远程站场输出的代表，同时元素爆发可提供稳定的后台冰附着。' },
      { type: 'heading', text: '输出要点' },
      { type: 'list', items: ['优先瞄准弱点以触发暴击', '瞄准时注意走位，避免被打断蓄力', '元素爆发为持续时间内的范围挂冰'] },
      { type: 'heading', text: '推荐配队' },
      { type: 'list', items: ['融化流：甘雨 + 香菱 + 钟离 + 班尼特', '冻结流：甘雨 + 莫娜 + 迪奥娜 + 温迪'] },
      { type: 'tip', text: '阿莫斯之弓与「冰风迷途的勇士」四件套是经典搭配，副词条优先暴击伤害与攻击力。' },
    ],
  },
  {
    id: 'guide-raiden',
    title: '雷电将军攻略：梦想一心与充能循环详解',
    cover:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20an%20elegant%20woman%20with%20long%20purple%20hair%20and%20violet%20eyes%20wearing%20an%20ornate%20purple%20kimono%20with%20gold%20accents%20dramatic%20soft%20light%20plain%20cream%20gradient%20background&width=800&height=500&seq=char-raiden&orientation=portrait',
    date: '2026-09-29',
    category: '角色攻略',
    type: 'guide',
    summary:
      '雷电将军是雷元素五星长柄武器角色，兼具强力爆发输出与全队充能恢复，是雷系体系的核心辅助输出。',
    author: '攻略组 · 林澈',
    tags: ['雷电将军', '雷元素', '充能', '副C'],
    readTime: '8 分钟',
    views: 53210,
    likes: 3670,
    content: [
      { type: 'heading', text: '角色定位' },
      { type: 'paragraph', text: '雷电将军的元素爆发「奥义 · 梦想真说」在梦想一心状态下提供高额雷伤，并在结束后为全队恢复元素能量，是兼具输出与循环稳定的核心角色。' },
      { type: 'heading', text: '充能循环要点' },
      { type: 'list', items: ['大招前先开启元素战技叠加愿力', '梦想一心状态打完约7段输出', '暴击率与充能效率需兼顾，建议充能效率约220%以上'] },
      { type: 'heading', text: '推荐配队' },
      { type: 'list', items: ['雷九万班：雷电将军 + 纳西妲 + 万叶 + 班尼特', '雷神国家队：雷电将军 + 香菱 + 行秋 + 班尼特'] },
      { type: 'tip', text: '「绝缘之旗印」四件套是其核心圣遗物，可将充能效率转化为爆发伤害加成。' },
    ],
  },
  {
    id: 'guide-nahida',
    title: '纳西妲攻略：灭净三业标记与草反应体系',
    cover:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20small%20cute%20girl%20with%20white%20green%20hair%20and%20green%20eyes%20wearing%20a%20white%20and%20green%20dress%20with%20leaf%20motifs%20soft%20natural%20light%20plain%20cream%20gradient%20background&width=800&height=500&seq=char-nahida&orientation=portrait',
    date: '2026-09-26',
    category: '角色攻略',
    type: 'guide',
    summary:
      '纳西妲是草元素五星法器角色，元素战技可标记敌人并协同触发草元素反应，是草系体系的核心辅助。',
    author: '攻略组 · 苏澈',
    tags: ['纳西妲', '草元素', '辅助', '反应'],
    readTime: '7 分钟',
    views: 49870,
    likes: 3340,
    content: [
      { type: 'heading', text: '角色定位' },
      { type: 'paragraph', text: '纳西妲的元素战技「所闻遍计」可标记至多8名敌人，被标记的敌人触发元素反应时会受到额外的灭净三业伤害，是草系反应队的核心增益来源。' },
      { type: 'heading', text: '培养要点' },
      { type: 'list', items: ['元素战技优先升级，提升标记伤害', '元素精通为其核心属性，直接影响反应收益', '元素爆发可提升全队元素精通'] },
      { type: 'heading', text: '推荐配队' },
      { type: 'list', items: ['超绽放：纳西妲 + 行秋 + 久岐忍 + 白术', '激化队：纳西妲 + 赛诺 + 八重神子 + 钟离'] },
      { type: 'tip', text: '「深林的记忆」与「饰金之梦」均可使用，副词条优先元素精通与充能效率。' },
    ],
  },
  {
    id: 'guide-kazuha',
    title: '枫原万叶攻略：聚怪增伤与元素扩散技巧',
    cover:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20calm%20young%20man%20with%20white%20red%20hair%20and%20red%20eyes%20wearing%20a%20traditional%20red%20and%20black%20robe%20with%20a%20sword%20soft%20windy%20light%20plain%20cream%20gradient%20background&width=800&height=500&seq=char-kazuha&orientation=portrait',
    date: '2026-09-24',
    category: '角色攻略',
    type: 'guide',
    summary:
      '枫原万叶是风元素五星单手剑角色，凭借元素战技聚怪与扩散增伤，是当前最强泛用辅助之一。',
    author: '攻略组 · 林澈',
    tags: ['万叶', '风元素', '辅助', '扩散'],
    readTime: '6 分钟',
    views: 54120,
    likes: 3720,
    content: [
      { type: 'heading', text: '角色定位' },
      { type: 'paragraph', text: '万叶的元素战技「千早振」可吸附周围敌人元素并扩散，配合天赋「风物之诗咏」为全队提供元素伤害加成，是几乎所有队伍的万能辅助。' },
      { type: 'heading', text: '操作要点' },
      { type: 'list', items: ['先由队友挂元素，再使用万叶战技扩散以触发增伤', '元素爆发「万叶之一刀」提供持续聚怪与扩散', '元素精通越高增伤越多'] },
      { type: 'heading', text: '推荐配队' },
      { type: 'list', items: ['通用：任意主C + 万叶 + 钟离 + 班尼特', '绽放辅助：万叶 + 纳西妲 + 行秋 + 妮露（需注意水火分别扩散）'] },
      { type: 'tip', text: '「翠绿之影」四件套可提供额外减抗，副词条优先元素精通与充能效率。' },
    ],
  },
  {
    id: 'guide-xiao',
    title: '魈攻略：靖妖傩舞下落攻击输出循环',
    cover:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20fierce%20young%20man%20with%20teal%20green%20hair%20and%20golden%20eyes%20wearing%20a%20dark%20green%20outfit%20with%20gold%20ornaments%20dramatic%20soft%20light%20plain%20cream%20gradient%20background&width=800&height=500&seq=char-xiao&orientation=portrait',
    date: '2026-09-21',
    category: '角色攻略',
    type: 'guide',
    summary:
      '魈是风元素五星长柄武器角色，靖妖傩舞状态下以下落攻击进行高频输出，是经典的风系站场主C。',
    author: '攻略组 · 苏澈',
    tags: ['魈', '风元素', '主C', '下落攻击'],
    readTime: '7 分钟',
    views: 41230,
    likes: 2460,
    content: [
      { type: 'heading', text: '角色定位' },
      { type: 'paragraph', text: '魈的核心机制在于元素爆发「靖妖傩舞」，开启后大幅提升跳跃能力与下落攻击伤害，但会持续扣除生命值，需要搭配治疗角色使用。' },
      { type: 'heading', text: '输出循环' },
      { type: 'list', items: ['开启元素爆发后进行连续下落攻击', '保持高度以触发范围伤害', '血量下降过快时及时治疗或关闭状态'] },
      { type: 'heading', text: '推荐配队' },
      { type: 'list', items: ['魈 + 钟离 + 班尼特 + 香菱', '魈 + 枫原万叶 + 钟离 + 治疗角色'] },
      { type: 'tip', text: '和璞鸢与「辰砂往生录」四件套是当前最优选择，副词条优先暴击率与暴击伤害。' },
    ],
  },
  {
    id: 'guide-neuvilette',
    title: '那维莱特攻略：衡平推裁重击机制解析',
    cover:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20an%20elegant%20tall%20man%20with%20long%20silver%20blue%20hair%20and%20blue%20eyes%20wearing%20a%20dark%20blue%20ornate%20coat%20with%20gold%20details%20cool%20soft%20light%20plain%20cream%20gradient%20background&width=800&height=500&seq=char-neuvilette&orientation=portrait',
    date: '2026-09-19',
    category: '角色攻略',
    type: 'guide',
    summary:
      '那维莱特是水元素五星法器角色，以蓄力重击「衡平推裁」进行持续高额输出，是当前水系顶级主C。',
    author: '攻略组 · 林澈',
    tags: ['那维莱特', '水元素', '主C', '重击'],
    readTime: '8 分钟',
    views: 52340,
    likes: 3610,
    content: [
      { type: 'heading', text: '角色定位' },
      { type: 'paragraph', text: '那维莱特的元素战技与爆发可生成源水之滴，吸收后为蓄力重击「衡平推裁」充能，使其成为以重击为核心的站场输出角色，范围伤害极为可观。' },
      { type: 'heading', text: '操作要点' },
      { type: 'list', items: ['先使用战技生成源水之滴，再蓄力重击', '重击期间可持续移动调整角度', '优先保证生命值上限以提升伤害'] },
      { type: 'heading', text: '推荐配队' },
      { type: 'list', items: ['那维莱特 + 芙宁娜 + 钟离 + 万叶', '那维莱特 + 夜兰 + 钟离 + 白术'] },
      { type: 'tip', text: '「逐影猎人」四件套可稳定提升重击伤害，副词条优先生命值与暴击属性。' },
    ],
  },
  {
    id: 'guide-xiangling',
    title: '香菱攻略：锅巴出击与旋火轮副C培养指南',
    cover:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20cheerful%20young%20chef%20girl%20with%20short%20brown%20hair%20and%20red%20eyes%20wearing%20an%20orange%20and%20white%20outfit%20with%20spicy%20pepper%20motifs%20warm%20light%20plain%20cream%20gradient%20background&width=800&height=500&seq=char-xiangling&orientation=portrait',
    date: '2026-09-16',
    category: '角色攻略',
    type: 'guide',
    summary:
      '香菱是火元素四星长柄武器角色，凭借元素爆发旋火轮的超高后台挂火能力，成为性价比极高的副C与增伤工具人。',
    author: '攻略组 · 苏澈',
    tags: ['香菱', '火元素', '副C', '四星'],
    readTime: '6 分钟',
    views: 44780,
    likes: 2810,
    content: [
      { type: 'heading', text: '角色定位' },
      { type: 'paragraph', text: '香菱的元素爆发「旋火轮」可持续跟随角色并造成高频火元素伤害，是蒸发、融化体系的优质后台挂火来源，虽为四星却拥有极高强度。' },
      { type: 'heading', text: '培养要点' },
      { type: 'list', items: ['元素爆发优先升级，为主要输出手段', '元素充能效率建议堆到约200%以保证循环', '元素精通对蒸发反应收益明显'] },
      { type: 'heading', text: '推荐配队' },
      { type: 'list', items: ['香菱 + 行秋 + 班尼特 + 万叶（蒸发队）', '香菱 + 甘雨 + 钟离 + 班尼特（融化队）'] },
      { type: 'tip', text: '「绝缘之旗印」四件套是通用选择，四星武器中西风长枪可显著缓解充能压力。' },
    ],
  },
  {
    id: 'guide-xingqiu',
    title: '行秋攻略：古华剑法雨帘剑与后台挂水',
    cover:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20refined%20young%20man%20with%20dark%20blue%20hair%20and%20blue%20eyes%20wearing%20a%20blue%20and%20white%20scholar%20robe%20holding%20a%20sword%20soft%20light%20plain%20cream%20gradient%20background&width=800&height=500&seq=char-xingqiu&orientation=portrait',
    date: '2026-09-13',
    category: '角色攻略',
    type: 'guide',
    summary:
      '行秋是水元素四星单手剑角色，元素爆发的雨帘剑提供稳定后台挂水与减伤，是蒸发与绽放体系的关键辅助。',
    author: '攻略组 · 林澈',
    tags: ['行秋', '水元素', '副C', '四星'],
    readTime: '6 分钟',
    views: 42150,
    likes: 2670,
    content: [
      { type: 'heading', text: '角色定位' },
      { type: 'paragraph', text: '行秋的元素爆发「古华剑 · 裁雨留虹」可持续生成雨帘剑，为站场角色提供额外水元素附着与伤害减免，是几乎所有火系主C的黄金搭档。' },
      { type: 'heading', text: '培养要点' },
      { type: 'list', items: ['元素爆发优先升级', '元素充能效率建议约180%以保证循环', '元素战技提供减伤与挂水'] },
      { type: 'heading', text: '推荐配队' },
      { type: 'list', items: ['胡桃 + 行秋 + 钟离 + 万叶', '纳西妲 + 行秋 + 久岐忍 + 白术（超绽放）'] },
      { type: 'tip', text: '「沉沦之心」或「绝缘之旗印」均可使用，副词条优先充能效率与暴击属性。' },
    ],
  },
  {
    id: 'guide-ayaka',
    title: '神里绫华攻略：神里流霜灭与冻结流配队',
    cover:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20an%20elegant%20young%20woman%20with%20long%20white%20blue%20hair%20and%20blue%20eyes%20wearing%20a%20blue%20and%20white%20kimono%20with%20snowflake%20motifs%20cool%20soft%20light%20plain%20cream%20gradient%20background&width=800&height=500&seq=char-ayaka&orientation=portrait',
    date: '2026-09-11',
    category: '角色攻略',
    type: 'guide',
    summary:
      '神里绫华是冰元素五星单手剑角色，以冻结流与元素爆发神里流霜灭为核心，拥有出色的爆发与机动性。',
    author: '攻略组 · 苏澈',
    tags: ['神里绫华', '冰元素', '主C', '冻结'],
    readTime: '7 分钟',
    views: 46720,
    likes: 2980,
    content: [
      { type: 'heading', text: '角色定位' },
      { type: 'paragraph', text: '神里绫华的冲刺附带冰元素并提供附魔，配合元素爆发「神里流 · 霜灭」的多段切割伤害，是冻结体系中稳定高效的主C。' },
      { type: 'heading', text: '输出要点' },
      { type: 'list', items: ['使用冲刺触发附魔后再进行普攻与重击', '元素爆发尽量对准聚集的敌人', '保持敌人处于冻结状态以稳定输出'] },
      { type: 'heading', text: '推荐配队' },
      { type: 'list', items: ['绫华 + 莫娜 + 万叶 + 迪奥娜（永冻队）', '绫华 + 申鹤 + 万叶 + 心海（永冻队）'] },
      { type: 'tip', text: '「冰风迷途的勇士」四件套在冻结状态下可提供高额暴击率，副词条优先暴击伤害与攻击力。' },
    ],
  },
  {
    id: 'guide-diluc',
    title: '迪卢克攻略：黎明剑与重击输出手法',
    cover:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20serious%20young%20man%20with%20red%20hair%20and%20red%20eyes%20wearing%20a%20black%20and%20red%20coat%20holding%20a%20claymore%20warm%20dramatic%20light%20plain%20cream%20gradient%20background&width=800&height=500&seq=char-diluc&orientation=portrait',
    date: '2026-09-08',
    category: '角色攻略',
    type: 'guide',
    summary:
      '迪卢克是火元素五星双手剑角色，以流畅的重击与元素附魔输出见长，是经典的火系主C之一。',
    author: '攻略组 · 林澈',
    tags: ['迪卢克', '火元素', '主C', '双手剑'],
    readTime: '6 分钟',
    views: 33240,
    likes: 1740,
    content: [
      { type: 'heading', text: '角色定位' },
      { type: 'paragraph', text: '迪卢克通过元素爆发「黎明」为武器附魔火元素，并衔接多段重击打出高额伤害，操作手感流畅，适合新手进阶使用。' },
      { type: 'heading', text: '输出手法' },
      { type: 'list', items: ['元素战技可三段连击并衔接普攻', '元素爆发附魔期间使用重击', '利用冲刺取消后摇以提升输出效率'] },
      { type: 'heading', text: '推荐配队' },
      { type: 'list', items: ['迪卢克 + 行秋 + 钟离 + 班尼特', '迪卢克 + 万叶 + 钟离 + 云堇'] },
      { type: 'tip', text: '「炽烈的炎之魔女」四件套是传统选择，副词条优先暴击率与暴击伤害。' },
    ],
  },
  {
    id: 'guide-keqing',
    title: '刻晴攻略：雷元素输出流派与手法选择',
    cover:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20an%20elegant%20young%20woman%20with%20purple%20hair%20in%20twin%20tails%20and%20violet%20eyes%20wearing%20a%20purple%20and%20gold%20dress%20holding%20a%20sword%20soft%20light%20plain%20cream%20gradient%20background&width=800&height=500&seq=char-keqing&orientation=portrait',
    date: '2026-09-05',
    category: '角色攻略',
    type: 'guide',
    summary:
      '刻晴是雷元素五星单手剑角色，以高速普攻与重击见长，可选雷伤与物伤两种流派，操作上限较高。',
    author: '攻略组 · 苏澈',
    tags: ['刻晴', '雷元素', '主C', '单手剑'],
    readTime: '6 分钟',
    views: 29870,
    likes: 1420,
    content: [
      { type: 'heading', text: '角色定位' },
      { type: 'paragraph', text: '刻晴的元素战技可瞬移并蓄力标记，配合重击打出高额伤害，整体手感轻盈流畅，兼具爆发与机动性。' },
      { type: 'heading', text: '流派选择' },
      { type: 'list', items: ['雷伤流：以元素爆发与附魔普攻为主', '物伤流：以贯通打击的普攻与重击为主', '两种流派对应不同圣遗物与武器选择'] },
      { type: 'heading', text: '推荐配队' },
      { type: 'list', items: ['刻晴 + 纳西妲 + 万叶 + 钟离', '刻晴 + 行秋 + 钟离 + 班尼特'] },
      { type: 'tip', text: '「如雷的盛怒」四件套适合雷伤流，可通过触发感电减少元素战技冷却。' },
    ],
  },
  {
    id: 'guide-bennett',
    title: '班尼特攻略：鼓舞领域增伤与治疗全解析',
    cover:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20an%20energetic%20young%20boy%20with%20blonde%20hair%20and%20green%20eyes%20wearing%20a%20green%20and%20white%20adventurer%20outfit%20holding%20a%20sword%20warm%20light%20plain%20cream%20gradient%20background&width=800&height=500&seq=char-bennett&orientation=portrait',
    date: '2026-09-02',
    category: '角色攻略',
    type: 'guide',
    summary:
      '班尼特是火元素四星单手剑角色，元素爆发的鼓舞领域同时提供高额治疗与攻击力加成，是队伍的万能辅助。',
    author: '攻略组 · 林澈',
    tags: ['班尼特', '火元素', '辅助', '四星'],
    readTime: '6 分钟',
    views: 48230,
    likes: 3120,
    content: [
      { type: 'heading', text: '角色定位' },
      { type: 'paragraph', text: '班尼特的元素爆发「美妙旅程」可生成鼓舞领域，为范围内角色提供持续治疗与攻击力加成，被玩家称为「六星火神」。' },
      { type: 'heading', text: '培养要点' },
      { type: 'list', items: ['元素爆发优先升级，直接影响增伤与治疗', '元素充能效率建议约200%以保证循环', '一命可解除攻击力加成生命值限制'] },
      { type: 'heading', text: '推荐配队' },
      { type: 'list', items: ['几乎所有主C + 班尼特 + 万叶 + 钟离', '国家队：香菱 + 行秋 + 班尼特 + 万叶'] },
      { type: 'tip', text: '「昔日宗室之仪」四件套可在释放爆发后提升全队攻击力，副词条优先充能效率与生命值。' },
    ],
  },
  {
    id: 'guide-venti',
    title: '温迪攻略：诗与歌的咏叹者与聚怪技巧',
    cover:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20a%20cheerful%20young%20bard%20man%20with%20dark%20green%20braided%20hair%20and%20green%20eyes%20wearing%20a%20green%20and%20white%20outfit%20holding%20a%20lyre%20soft%20breezy%20light%20plain%20cream%20gradient%20background&width=800&height=500&seq=char-venti&orientation=portrait',
    date: '2026-08-30',
    category: '角色攻略',
    type: 'guide',
    summary:
      '温迪是风元素五星弓角色，元素爆发可制造大型风场持续聚怪并附着元素，是清理成群敌人的强力辅助。',
    author: '攻略组 · 苏澈',
    tags: ['温迪', '风元素', '辅助', '聚怪'],
    readTime: '6 分钟',
    views: 35680,
    likes: 1880,
    content: [
      { type: 'heading', text: '角色定位' },
      { type: 'paragraph', text: '温迪的元素爆发「风神之诗」可生成持续吸附敌人的风场，并附加扩散元素伤害，在面对大量敌人的场景中表现尤为突出。' },
      { type: 'heading', text: '操作要点' },
      { type: 'list', items: ['元素爆发可吸附中小型敌人', '先挂元素再扩散以触发增伤', '与飞行或远程角色搭配效果更佳'] },
      { type: 'heading', text: '推荐配队' },
      { type: 'list', items: ['温迪 + 甘雨 + 莫娜 + 迪奥娜（冻结队）', '温迪 + 任意主C + 钟离 + 班尼特'] },
      { type: 'tip', text: '「翠绿之影」四件套可提供减抗，副词条优先元素精通与充能效率。' },
    ],
  },
  {
    id: 'guide-yelan',
    title: '夜兰攻略：萦络纵命索与后台挂水输出',
    cover:
      'https://readdy.ai/api/search-image?query=Genshin%20Impact%20style%20anime%20portrait%20of%20an%20elegant%20woman%20with%20short%20dark%20blue%20hair%20and%20blue%20eyes%20wearing%20a%20dark%20blue%20and%20gold%20qipao%20with%20jade%20accents%20soft%20cool%20light%20plain%20cream%20gradient%20background&width=800&height=500&seq=char-yelan&orientation=portrait',
    date: '2026-08-27',
    category: '角色攻略',
    type: 'guide',
    summary:
      '夜兰是水元素五星弓角色，凭借元素爆发的后台高频挂水与生命值加伤机制，成为顶级副C与增伤辅助。',
    author: '攻略组 · 林澈',
    tags: ['夜兰', '水元素', '副C', '后台'],
    readTime: '7 分钟',
    views: 50980,
    likes: 3410,
    content: [
      { type: 'heading', text: '角色定位' },
      { type: 'paragraph', text: '夜兰的元素爆发「渊图玲珑骰」可持续在后台造成水元素伤害，其伤害基于生命值上限，兼具输出与增伤能力，适配多种火系主C。' },
      { type: 'heading', text: '培养要点' },
      { type: 'list', items: ['元素爆发优先升级', '生命值上限为核心属性', '元素充能效率建议约180%以保证循环'] },
      { type: 'heading', text: '推荐配队' },
      { type: 'list', items: ['那维莱特 + 夜兰 + 钟离 + 万叶', '胡桃 + 夜兰 + 钟离 + 万叶'] },
      { type: 'tip', text: '「沉沦之心」四件套可提升水元素伤害，副词条优先生命值、暴击与充能效率。' },
    ],
  },
];